module.exports = __webpack_public_path__ + "static/media/auto-1.781225a2.png";